import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Switch } from "react-router";

import { listOfSaleOrderTrackingUrl, listOfSaleOrderUrl } from "./urls";
import ListOfSalesOrderView from "./views/ListOfSalesOrder";

const ListOfSalesOrder = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.listOfSaleOrder)} />
      <Switch>
        <Route
          exact
          path={listOfSaleOrderUrl}
          component={ListOfSalesOrderView}
        />
        <Route
          exact
          path={listOfSaleOrderTrackingUrl}
          component={ListOfSalesOrderView}
        />
      </Switch>
    </>
  );
};

export default ListOfSalesOrder;
